import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Pay = ({
  size,
  type,
  theme,
  className,
  dataTestId = "pay-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.986 1.388c-.737 0-1.334.597-1.334 1.334v.7h-.997c-.736 0-1.333.596-1.333 1.332v.7h-.954c-.736 0-1.333.597-1.333 1.333v6.491c0 .736.597 1.333 1.333 1.333H14.63c.737 0 1.334-.597 1.334-1.333V6.787c0-.736-.597-1.333-1.334-1.333H3.655v-.7h11.642a.667.667 0 0 0 0-1.333H5.986v-.7h9.31a.667.667 0 0 0 0-1.332h-9.31ZM1.368 6.787H14.63v6.491H1.368V6.787Zm5.624 3.27c0-.809.544-1.285 1.008-1.285.464 0 1.007.476 1.007 1.285 0 .81-.543 1.285-1.007 1.285-.464 0-1.008-.475-1.008-1.285ZM8 7.44c-1.385 0-2.341 1.272-2.341 2.618 0 1.347.956 2.619 2.34 2.619 1.386 0 2.342-1.272 2.342-2.619C10.34 8.711 9.385 7.44 8 7.44Zm3.38 2.594c0-.369.299-.667.667-.667h.799a.667.667 0 1 1 0 1.333h-.8a.667.667 0 0 1-.666-.666Zm-8.228-.667a.667.667 0 0 0 0 1.333h.8a.667.667 0 1 0 0-1.333h-.8Z"
    />
  </SVGIcon>
);
